module.exports = __webpack_public_path__ + "img/linkedin.b129f6ea.svg";